import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import {MatInputModule} from '@angular/material/input';
// import {MatButtonModule, MatCheckboxModule} from '@angular/material';

@NgModule({
  imports: [
    CommonModule,
    // MatInputModule
  ],
  declarations: [],
  exports: []
})
export class materialUI { }



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/module/new-pages/materialUI.ts